<template>
  <div>
    <my-company></my-company>
  </div>
</template>

<script>
export default {
  name: 'ProfilCompanyInfo',
  components: {
    myCompany: () => import('@/components/relations/myCompany')
  }
}
</script>
